// extracted by mini-css-extract-plugin
export default {"container":"ProfileSidebar_container__oJHzG","categoryList":"ProfileSidebar_categoryList__WFA9H"};